function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var LayersIcon = function LayersIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.68555L9 1.1272L16 4.68555L9 8.24389L2 4.68555Z",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.375 6.79557L5.5 7.24036L2 9.01953L9 12.5779L16 9.01953L12.5 7.24036L11.625 6.79557",
    stroke: "#626B77",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 11.1286L12.5 11.5734L16 13.3525L9 16.9109L2 13.3525L5.5 11.5734L6.375 11.1286",
    stroke: "#626B77",
    strokeWidth: "1.5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "18",
    height: "18",
    fill: "white"
  }))));
};

export default LayersIcon;